import { StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * DateSeriesPointTooltip: this tooltip displays date for: the date, series and the point.
 */
export class DateSeriesPointTooltip {
	public static getFormatter(): Function {
		return function (): string {
			let out =
				'<div style="white-space:normal;">' +
				'<h4 class="title">' +
				Highcharts.dateFormat('%a, %b %e, %Y', this.x) +
				'</h4>' +
				'<table style="table-layout:fixed; width: 160px;">';
			this.points.forEach(point => {
				const seriesColor = point.series.color;
				out +=
					'<tr><td style="color: ' +
					seriesColor +
					';">' +
					StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true) +
					'</td>' +
					'<td style="text-align: right;">' +
					'$' +
					Highcharts.numberFormat(point.y, 2, '.', ',') +
					'</td>' +
					'</tr>';
			});
			out += '</table></div>';
			return out;
		};
	}
}
